/**
 * Presta
 **/
(function($){

    //sliders
    // $('#slider').bxSlider({
    //     mode:'fade',
    //     speed:1000,
    //     slideWidth:1000,
    //     minSlides:1,
    //     maxSlides:1,
    //     moveSlides:1,
    //     slideMargin:0,
    //     pagerCustom: '#bx-pager',
    //     auto: true,
    //     captions: true,
    //     easing:'ease-in'
    // });

    // $('#slider-dispo').bxSlider({
    //     slideWidth: 196,
    //     slideMargin: 30,
    //     minSlides: 1,
    //     maxSlides: 4,
    //     infiniteLoop: false,
    //     hideControlOnEnd: true,
    //     pager: false,
    //     auto: false
    // });

  //sliders
  $('#slider').bxSlider({
    slideWidth:1000,
    minSlides:1,
    maxSlides:1,
    moveSlides:1,
    slideMargin:0,
    pagerCustom: '#bx-pager',
    auto: true,
    captions: true
  });

  // $('#slider-dispo').bxSlider({
  //   slideWidth: 196,
  //   slideMargin: 30,
  //   minSlides: 1,
  //   maxSlides: 4,
  //   pager: false,
  //   auto: false
  // });

  $('#slider-dispo').owlCarousel({
      margin:30,
      autoplay:false,
      dots: false,
      nav: true,
      navText: ['<i class="fa-thin fa-2x fa-angle-left" aria-hidden="true"></i>','<i class="fa-thin fa-2x fa-angle-right" aria-hidden="true"></i>'],
      responsive:{
          0:{
                nav: false,
                items:1
          },
          600:{
                items:3
          },
          1000:{
                items:4
          }
      }
  });

  //lightbox
  $(".fancybox").fancybox({
      openEffect	: 'none',
      closeEffect	: 'none',
      padding : 0
  });

  //reservation
var dayOfMonth = new Date().getDate();
$(".owl-booking").owlCarousel({
    center: false,
    margin: 4,
    loop: false,
    autoplay: false,
    startPosition: parseInt(dayOfMonth) -1,
    dots: false,
    nav: true,
    navText: ['<i class="fa-thin fa-2x fa-angle-left" aria-hidden="true"></i>','<i class="fa-thin fa-2x fa-angle-right" aria-hidden="true"></i>'],
    responsive:{
        0:{
            items:4,
            loop: false
        },
        1000:{
            items:12,
            loop:true
        }
    }
});

  $('.owl-booking button').click(function(){

      var date = $(this).data('date');
      var results = $('.results-reservation');

      if($(this).hasClass('success') || $(this).hasClass('info')){
          if ( results.is( ":hidden" ) ) {
              results.find('h3').prepend(date);
              results.find('input[name="date"]').val(date);
              results.slideDown("slow");
          } else {
              results.slideUp("slow", function(){
                  results.find('h3').empty();
                  results.find('h3').prepend(date);
                  results.find('input[name="date"]').val(date);
                  results.slideDown( "slow" );
              });
          }
      }else{
          swal.fire("L'activité n'est pas disponible à cette date", "", "error");
      }
  });

  $(".results-reservation .priceNb").on('change', function()
  {
      var price_nb = $(this).val();
      var price_montant = $(this).closest('.priceType').find('.priceMontant span').text();
      var target = $(this).closest('.priceType').find('.priceRow');

      target.val(price_montant * price_nb);

      var totalRow = 0;
      var nombreRow = 0;
      $('.price .priceRow').each(function()
      {
          var val_input = $(this).val();
          totalRow += parseFloat(val_input);
          nombreRow ++;

      });
      $('.priceCol').val(totalRow);

  });

})(jQuery);